/* Hero countdown: ticks down to the 1st of next month (DS Countdown stand-in) */
(function () {
  document.querySelectorAll('.value-hero-section .pl-countdown').forEach(function (el) {
    var end = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1);
    var pad = function (n) { return String(n).padStart(2, '0'); };

    function tick() {
      var diff = Math.max(0, end - new Date());
      var d = Math.floor(diff / 864e5); diff -= d * 864e5;
      var h = Math.floor(diff / 36e5); diff -= h * 36e5;
      var m = Math.floor(diff / 6e4); diff -= m * 6e4;
      var s = Math.floor(diff / 1e3);
      var values = { d: pad(d), h: pad(h), m: pad(m), s: pad(s) };

      el.querySelectorAll('[data-k]').forEach(function (node) {
        node.textContent = values[node.dataset.k];
      });
    }

    tick();
    setInterval(tick, 1000);
  });
})();